import CommonService from '../../../../services/commonService';
import React from 'react';

function TitleDesc(props) {
  return (
    <div key={props.key} className="env-strip-text-item">
      <div>
        <span className="font10">{props.t(props.val.title)}</span>
      </div>
      <div>
        <span className="font11 bold-text">
          {props.key === 0
            ? props.envData && props.envData.distance
              ? props.envData.distance + 'KM'
              : '0KM'
            : props.key === 1
            ? (props.envData && props.envData.carbon + 'M') || '7.3M'
            : props.key === 2
            ? (props.envData && props.envData.tree + 'M') || '1.23M'
            : CommonService.currency(props.envData && props.envData.price) || 'CLP $6000'}
        </span>
      </div>
    </div>
  );
}

export default TitleDesc;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/TitleDesc.js